var map = {
	"./db_algebra": [
		7304,
		304
	],
	"./db_algebra.json": [
		7304,
		304
	],
	"./db_c": [
		4254,
		254
	],
	"./db_c.json": [
		4254,
		254
	],
	"./db_cSharp": [
		6825,
		825
	],
	"./db_cSharp.json": [
		6825,
		825
	],
	"./db_computer_engineering": [
		868,
		868
	],
	"./db_computer_engineering.json": [
		868,
		868
	],
	"./db_computer_organisation": [
		6171,
		171
	],
	"./db_computer_organisation.json": [
		6171,
		171
	],
	"./db_cpp": [
		289,
		289
	],
	"./db_cpp.json": [
		289,
		289
	],
	"./db_cryptology": [
		8600,
		600
	],
	"./db_cryptology.json": [
		8600,
		600
	],
	"./db_cyber_security": [
		5139,
		139
	],
	"./db_cyber_security.json": [
		5139,
		139
	],
	"./db_data_structure": [
		9135,
		135
	],
	"./db_data_structure.json": [
		9135,
		135
	],
	"./db_database": [
		7928,
		928
	],
	"./db_database.json": [
		7928,
		928
	],
	"./db_discrete_computational_structures": [
		7773,
		773
	],
	"./db_discrete_computational_structures.json": [
		7773,
		773
	],
	"./db_english": [
		7258,
		258
	],
	"./db_english.json": [
		7258,
		258
	],
	"./db_iq": [
		3693,
		693
	],
	"./db_iq.json": [
		3693,
		693
	],
	"./db_java": [
		983,
		983
	],
	"./db_java.json": [
		983,
		983
	],
	"./db_javaScript": [
		5568,
		568
	],
	"./db_javaScript.json": [
		5568,
		568
	],
	"./db_math": [
		4635,
		635
	],
	"./db_math.json": [
		4635,
		635
	],
	"./db_network": [
		7930,
		930
	],
	"./db_network.json": [
		7930,
		930
	],
	"./db_operating_systems": [
		9300,
		300
	],
	"./db_operating_systems.json": [
		9300,
		300
	],
	"./db_physics": [
		9879,
		879
	],
	"./db_physics.json": [
		9879,
		879
	],
	"./db_python": [
		7507,
		507
	],
	"./db_python.json": [
		7507,
		507
	],
	"./db_r": [
		2637,
		637
	],
	"./db_r.json": [
		2637,
		637
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4912;
module.exports = webpackAsyncContext;